import { 
    useStripe, 
    useElements, 
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement
} from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../../stripe";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { useState } from "react";
import axiosInstance from "../../../axios-instance";
import { notification } from "../../../utils/utility";


const UpdateCardForm = ({toggle}) => {

  const ELEMENT_OPTIONS = {
    style: {
      base: {
        fontSize: "16px",
        color: "#495057",
        fontFamily: "Inter, Arial, sans-serif",
        "::placeholder": {
          color: "#6c757d",
        },
      },
      invalid: {
        color: "#dc3545",
      },
    },
  };

  const stripeInputStyle = {
    height: "38px",
    padding: "0.375rem 0.75rem",
    display: "flex",
    alignItems: "center",
  };

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!stripe || !elements) return;

    setLoading(true);

    try {
      // 1. Create payment method via Stripe.js
      const cardNumberElement = elements.getElement(CardNumberElement);
      const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
      });

      if (stripeError) {
        setError(stripeError.message);
        setLoading(false);
        return;
      }

      // 2. Send to backend to attach + set as default
      const res = await axiosInstance.post("/admin/subscription/update-card", {
        payment_method_id: paymentMethod.id,
      });

      if (res.data.success) {
        toggle(false);
        notification.success(res.data.message || "Card updated successfully.");
      } else {
        setError(res.data.message || "Failed to update card. Please try again.");
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Something went wrong. Please check your card details and try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-4">

      {/* Card Number */}
      <div className="mb-3">
        <label className="form-label">Card Number</label>
        <div className="form-control py-2" style={stripeInputStyle}>
          <CardNumberElement options={ELEMENT_OPTIONS} />
        </div>
      </div>

      {/* Expiry + CVC */}
      <Row className="mb-3">
        <Col md={6}>
          <label className="form-label">Expiry Date</label>
          <div className="form-control py-2" style={stripeInputStyle}>
            <CardExpiryElement options={ELEMENT_OPTIONS} />
          </div>
        </Col>

        <Col md={6}>
          <label className="form-label">CVC</label>
          <div className="form-control py-2" style={stripeInputStyle}>
            <CardCvcElement options={ELEMENT_OPTIONS} />
          </div>
        </Col>
      </Row>

      {error && <p className="text-danger mt-2">{error}</p>}

      <button
        type="submit"
        className="btn btn-app mt-4 w-100"
        disabled={loading || !stripe}
      >
        {loading ? "Processing..." : "Update Card"}
      </button>
    </form>
  );
};


const UpdateCardModal = (props) => {

    return (
        <Modal className="billing_modal" isOpen={true} toggle={() => { props.toggle(false) }}>
            <ModalHeader toggle={() => { props.toggle(false) }}>
                Update Card Detail
            </ModalHeader>
            <ModalBody className="p-0">
                <Elements 
                    stripe={stripePromise}
                    options={{
                    appearance: { theme: "stripe" },
                    }}>
                    <UpdateCardForm toggle={props.toggle}/>    
                </Elements>
            </ModalBody>
        </Modal>
    )
}

export default UpdateCardModal;